import { render, staticRenderFns } from "./924ca6f5-ab61-43fe-b9cb-987dd4d6a639.vue?vue&type=template&id=c10b4f6c&"
import script from "./924ca6f5-ab61-43fe-b9cb-987dd4d6a639.vue?vue&type=script&lang=js&"
export * from "./924ca6f5-ab61-43fe-b9cb-987dd4d6a639.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VRow,VSelect,VSheet,VTextField})
